import { atom } from 'jotai';
import { OrgLocation } from '../organizations/organizations.types';

export const locationAtom = atom<OrgLocation | null>(null);
